import { isFeatureEnabled } from '@client/core/atoms/unleashFeatures.js';
import { isFinnTravelObjectPage } from '@client/core/utils/travel/isFinnTravelObjectPage.js';
import { isFinnTravelResultPage } from '@client/core/utils/travel/isFinnTravelResultPage.js';
import { UNLEASH_FEATURE_NAME } from '@schibsted-nmp/advertising-shared';

export function ensurePathStartsWithSlash(path: string): string {
  return path.startsWith('/') ? path : `/${path}`;
}

export function removeWallpaperDiv() {
  const wallpaperDiv =
    typeof document !== 'undefined' &&
    document.getElementById('wallpaper-container');

  if (wallpaperDiv) wallpaperDiv.remove();
}

export function shouldUseSplitBatch() {
  return (
    isFeatureEnabled(UNLEASH_FEATURE_NAME.enableBatchRequestSplit) &&
    !isFinnTravelResultPage() &&
    !isFinnTravelObjectPage()
  );
}
